import React, { useEffect, useState, useRef, useCallback } from "react";
import PrimaryButton from "./PrimaryButton";
import { useDispatch } from "react-redux";
import { editMenuItem, refreshMenu } from "../../reducer/MenuReducer";
import { createMenu } from "../../services/menu";
import { FaX } from "react-icons/fa6";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import "./quillSticky.css";


const EditorQuill = ({ setPopup, setEdit, edit }) => {
  const [content, setContent] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (edit.isEdit) {
      setContent(edit.content);
    }
  }, [edit]);

  const quillRef = useRef(null); // To store the ReactQuill instance
  const setQuillRef = useCallback((ref) => { // Callback to set the ref and disable spellcheck
    if (ref) {
      quillRef.current = ref;
      // Access the internal Quill editor instance and set spellcheck to false
      const editor = ref.getEditor();
      if (editor && editor.root) {
        editor.root.setAttribute("spellcheck", "false");
      }
    }
  }, []);

  const handleChangeData = (value) => {
    setContent(value);
  };

  const newObject = {
    content: content,
  };

  const handleSaveMenu = async (e) => {
    e.preventDefault();

    try {
      if (edit.isEdit) {
        dispatch(editMenuItem(edit.id, newObject));
        setEdit({ isEdit: false });
        dispatch(refreshMenu());
        setPopup(true);
      } else {
        const data = await createMenu(newObject);
        if (data) {
          setContent("");
          setEdit({ shown: false });
          setPopup(true);
          dispatch(refreshMenu());
        }
      }
    } catch (exception) {
      console.error("saving menu error", exception);
    }
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold", "italic", "underline", "blockquote",
    "list", "bullet",
    "link", "image", "video"
  ];

  return (
    <div className="bg-dark text-black h-full grow max-w-screen-5xl p-4">
      <div className="flex justify-end pb-6">
        <FaX
          className="text-gray text-[22px] cursor-pointer max-sm:text-[18px]"
          onClick={() => {
            setEdit({ shown: false });
          }}
        />
      </div>
      <form className="flex flex-col gap-4 pb-2">
        <ReactQuill
            ref={setQuillRef}
          value={content}
          onChange={handleChangeData}
          modules={quillModules}
          formats={quillFormats}
          className="bg-gray text-black rounded w-full min-h-[300px] max-h-[400px] overflow-auto editor-sticky"
          theme="snow"
        />
        <PrimaryButton
          text="Save"
          onClick={handleSaveMenu}
          type="submit"
          className="max-lg:px-12 flex items-start"
        />
      </form>
    </div>
  );
};

export default EditorQuill;

